import clsx from 'clsx';
import { ButtonHTMLAttributes, ReactNode } from 'react';

import MuiButton from '@material-ui/core/Button';

import styles from './Button.module.scss';

/**
 * NOTE - Please use this button from now for design consistency and accessibility.
 * Don't hesitate to modify this button since its currently only has one variant and few implementations.
 */

type ButtonTrackEvent = {
  'element type': 'button';
  'element text': string;
};

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  onClick?: () => void;
  href?: string;
  disabled?: boolean;
  iconLeft?: JSX.Element;
  iconRight?: JSX.Element;
  trackFunction: ((trackEvent: ButtonTrackEvent) => void) | null;
  className?: string;
};

export const Button = ({
  children,
  onClick,
  href = '',
  disabled,
  trackFunction,
  iconLeft,
  iconRight,
  className,
}: ButtonProps) => (
  <div className={clsx(styles.container, className)}>
    <MuiButton
      className={styles.myButton}
      variant="contained"
      href={href}
      disabled={disabled}
      onClick={() => {
        if (disabled) {
          return;
        }
        trackFunction?.({
          'element text': children?.toString() ?? '',
          'element type': 'button',
        });
        onClick?.();
      }}
      startIcon={iconLeft}
      endIcon={iconRight}
    >
      {children}
    </MuiButton>
  </div>
);

export default Button;
